import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'  // elementUI的国际化
import messages from './langs'

Vue.use(VueI18n)

const i18n = new VueI18n({    // 从localStorage中取，没有就默认的中文
  locale: !JSON.parse(localStorage.getItem('lang')) ? 'en' : 'zh-CN',
  messages,
  silentTranslationWarn: true
})
locale.i18n((key, value) => i18n.t(key, value)) // 为了实现element插件的多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/project/i18n/i18n.js